import React from 'react';
import FormGroup from './FormGroup';
import s from './RadioGroup.scss';
import { abtest } from '../../../utils';
import { isMonotributo, getCategory } from '../ChatsForm/IncomeUtils';


const RadioGroup = ({
    label,
    name,
    errors,
    children,
    onChange,
    selected,
    smooth,
    tooltipDesc,
    flexButton,
    cross,
    text,
    showDescription,
    abtestData,
    category,
    income_type,
    selectedCategory
}) => {
    return (
        <FormGroup flexButton={flexButton} cross={cross} abtestData={abtestData} label={label} errors={errors} name ={'radio'} smooth={smooth} tooltipDesc={tooltipDesc} text={text} showDescription={showDescription} category={category}>
            {children.map(([label, value, description, hidden]) => {
                if (hidden){
                    return ("");
                }
                return (
                    <div key={value}>
                        <label className={`${s.label} ${flexButton ? s.flexButton : ''} ${(selected === value) ? s.chequeado : s.label} ${(category) ? s.categoryLabel : ''}`}>
                            <div className={s.inputLabel}>
                                <input type="radio" name={name} onChange={() => onChange({ target: { name, value } })} value={value} checked={selected === value} />
                                <div className={s.textLabel}>{label}</div>
                            </div>
                            {(isMonotributo(income_type) && (selected === value)) 
                            ? <RadioGroup label="¿Qué categoría?" errors={errors} onChange={onChange} name="category" selected={selectedCategory} category={true}>
                                {getCategory(income_type)}
                            </RadioGroup>
                            : null
                        }
                        </label>
                        {showDescription && (selected === value) && <p className={s.description}>{description}</p>}
                    </div>
                )
            })}
        </FormGroup>
    );
}
export default RadioGroup;
